import cx from 'classnames';
import {Fragment, useMemo} from 'react';

import {BrowserIcon, DeviceIcon, OsIcon} from 'components/icons';
import {AnyParticipant} from 'interfaces';
import {PlatformInfo} from 'types';
import {platformUtils, sessionUtils} from 'utils';

type Props = {
    participant: AnyParticipant;
    local?: boolean;
    osClassName?: string;
    browserClassName?: string;
};

export const ParticipantPlatform: React.FC<Props> = ({participant, local, osClassName, browserClassName}: Props) => {
    const localPlatformInfo = useMemo(() => local ? platformUtils.getPlatformInfo() : null, [local]);
    const participantPlatformInfo = useMemo(() => {
        let platformInfo: PlatformInfo = null;
        if (sessionUtils.isInviteeParticipant(participant)) {
            platformInfo = participant.data?.clientInfo;
        } else if (sessionUtils.isUserParticipant(participant)) {
            platformInfo = participant.data?.platformInfo;
        }

        if (!platformInfo && local) {
            platformInfo = localPlatformInfo;
        }

        return platformInfo;
    }, [participant, localPlatformInfo, local]);

    if (participantPlatformInfo) {
        return (
            <Fragment>
                <OsIcon os={participantPlatformInfo?.os} className={cx('tw-mr-1', osClassName)} />
                <BrowserIcon browser={participantPlatformInfo?.browser} className={browserClassName} />
            </Fragment>);
    }
    if (sessionUtils.isInviteeParticipant(participant)) {
        return <DeviceIcon device={participant.data.device} className={cx('tw-mr-1', osClassName)} />;
    }

    return null;
};